import { Page } from '.';

export class PushNotification {
  id: string;
  alert: string;
  pushTime: string;
  pushDateObject: Date;
  targetID: string;
  targetPage: Page;

  constructor(json: any) {
    this.id = json.id;
    this.alert = json.alert;
    this.pushTime = json.push_time;
    this.pushDateObject = new Date(this.pushTime);
    this.targetID = json.target;
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/push.model.ts